import { useTranslation } from "react-i18next";

const { Dialog, DialogTitle, DialogContent, Typography, DialogActions } = require("@mui/material");
const { default: ElevatedButton } = require("components/Button/ElevatedButton");

const ConfirmationDialog = ({
    title,
    message,
    open,
    onClose,
    onConfirm,
    field
}) => {
    const { t } = useTranslation();

    return (
        <Dialog
            open={open}
            onClose={(event, reason) => {
                if (reason !== 'backdropClick') {
                    onClose();
                }
            }}
            maxWidth="xs"
            fullWidth
            disableEscapeKeyDown={false}
        >
            <DialogTitle>
                {title}
            </DialogTitle>
            <DialogContent>
                <Typography>
                    {message}
                </Typography>
            </DialogContent>
            <DialogActions>
                <ElevatedButton
                    type="cancel"
                    onClick={onClose}
                    size="small"
                >
                    {t('cancel')}
                </ElevatedButton>
                <ElevatedButton
                    type={field?.status ? "error" : "submit"}
                    onClick={onConfirm}
                    size="small"
                >
                    {t('confirm')}
                </ElevatedButton>
            </DialogActions>
        </Dialog>
    );
};

export default ConfirmationDialog;